"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgChrome = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M24 13a11.002 11.002 0 0110.068 6.56l.04.096C34.683 20.988 35 22.457 35 24c0 6.075-4.925 11-11 11a11.125 11.125 0 01-1.31-.078C17.233 34.275 13 29.632 13 24c0-2.42.781-4.656 2.105-6.472a.874.874 0 01.098-.133A10.984 10.984 0 0124 13zm8.488 8H28c.628.835 1 1.874 1 3 0 .972-.277 1.88-.757 2.647l-3.654 6.334a9 9 0 007.899-11.98zM15 24c0 4.408 3.17 8.077 7.354 8.85l2.242-3.885a5 5 0 01-5.02-2.632l-3.649-6.316A8.963 8.963 0 0015 24zm9-3a3 3 0 00-2.662 4.384l.068.116.016.036a2.998 2.998 0 005.102.086l.07-.122.032-.049A3 3 0 0024 21zm0-6a8.98 8.98 0 00-6.841 3.152l2.243 3.881A5.001 5.001 0 0124 19h7.484A8.991 8.991 0 0024 15z",
    id: "chrome_svg__a"
  }));
};

var _default = SvgChrome;
exports.default = _default;